import React, { useState, useEffect } from 'react';
import '../Nucleos/Nucleos.css';
import './AtividadesCNAE.css';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import Toggle from '../../../Common/Toggle/Toggle';
import API_BASE_URL from '../../../../config/api';

const AtividadesCNAE = () => {
  const [atividades, setAtividades] = useState([]);
  const [orgaosReferencia, setOrgaosReferencia] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    secao: '',
    divisao: '',
    grupo: '',
    classe: '',
    subclasse: '',
    dig: '',
    ref: '',
    descricao: '',
    ativo: true
  });

  const carregarAtividades = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/cnae`);

      if (!response.ok) {
        throw new Error('Erro ao buscar atividades CNAE');
      }

      const data = await response.json();
      setAtividades(data);
    } catch (error) {
      console.error('Erro ao carregar atividades CNAE:', error);
      alert(
        'Erro ao carregar atividades CNAE. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const carregarOrgaosReferencia = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/orgaos-referencia`);

        if (!response.ok) {
          throw new Error('Erro ao buscar órgãos de referência');
        }

        const data = await response.json();
        setOrgaosReferencia(
          data.map((item) => ({
            id: item.id_orgao_referencia,
            nome_orgao_referencia: item.nome_orgao_referencia,
            sigla: item.sigla,
            ativo: item.ativo
          }))
        );
      } catch (error) {
        console.error('Erro ao carregar órgãos de referência:', error);
        setOrgaosReferencia([]);
      }
    };

    carregarAtividades();
    carregarOrgaosReferencia();
  }, []);

  const normalizeText = (value) =>
    value
      ? value
          .toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      : '';

  const filteredAtividades = atividades.filter((atividade) => {
    const termoNormalizado = normalizeText(searchTerm);

    if (!termoNormalizado) {
      return true;
    }

    const descricao = normalizeText(atividade.descricao);
    const classe = normalizeText(atividade.classe);
    const subclasse = normalizeText(atividade.subclasse);
    const secao = normalizeText(atividade.secao);
    const divisao = normalizeText(atividade.divisao);
    const grupo = normalizeText(atividade.grupo);
    const dig = normalizeText(atividade.dig);
    const ref = normalizeText(atividade.ref);
    const referenciaNome = normalizeText(atividade.referencia_nome);

    return (
      descricao.includes(termoNormalizado) ||
      classe.includes(termoNormalizado) ||
      subclasse.includes(termoNormalizado) ||
      secao.includes(termoNormalizado) ||
      divisao.includes(termoNormalizado) ||
      grupo.includes(termoNormalizado) ||
      dig.includes(termoNormalizado) ||
      ref.includes(termoNormalizado) ||
      referenciaNome.includes(termoNormalizado)
    );
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      secao: '',
      divisao: '',
      grupo: '',
      classe: '',
      subclasse: '',
      dig: '',
      ref: '',
      descricao: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleEdit = (atividade) => {
    setFormData({
      secao: atividade.secao || '',
      divisao: atividade.divisao || '',
      grupo: atividade.grupo || '',
      classe: atividade.classe || '',
      subclasse: atividade.subclasse || '',
      dig: atividade.dig || '',
      ref: atividade.referencia_id ? String(atividade.referencia_id) : '',
      descricao: atividade.descricao || '',
      ativo: atividade.ativo !== undefined ? atividade.ativo : true
    });
    setEditingId(atividade.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta atividade CNAE?')) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/cnae/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error('Erro ao excluir atividade CNAE');
      }

      setAtividades((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Erro ao excluir atividade CNAE:', error);
      alert('Erro ao excluir atividade CNAE. Tente novamente.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const url = editingId
        ? `${API_BASE_URL}/cnae/${editingId}`
        : `${API_BASE_URL}/cnae`;
      
      const method = editingId ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          ref: formData.ref ? Number(formData.ref) : null,
          ativo: formData.ativo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao salvar atividade CNAE');
      }

      const data = await response.json();

      if (editingId) {
        setAtividades((prev) =>
          prev.map((item) => (item.id === editingId ? data : item))
        );
      } else {
        setAtividades((prev) => [...prev, data]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar atividade CNAE:', error);
      alert('Erro ao salvar atividade CNAE. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Atividades CNAE</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Atividade CNAE' : 'Cadastrar Atividade CNAE'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="secao">Seção</label>
                <input
                  type="text"
                  id="secao"
                  name="secao"
                  value={formData.secao}
                  onChange={handleInputChange}
                  placeholder="Ex: A"
                />
              </div>
              <div className="form-group">
                <label htmlFor="divisao">Divisão</label>
                <input
                  type="text"
                  id="divisao"
                  name="divisao"
                  value={formData.divisao}
                  onChange={handleInputChange}
                  placeholder="Ex: 01"
                />
              </div>
              <div className="form-group">
                <label htmlFor="grupo">Grupo</label>
                <input
                  type="text"
                  id="grupo"
                  name="grupo"
                  value={formData.grupo}
                  onChange={handleInputChange}
                  placeholder="Ex: 01.1"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="classe">Classe</label>
                <input
                  type="text"
                  id="classe"
                  name="classe"
                  value={formData.classe}
                  onChange={handleInputChange}
                  placeholder="Ex: 01.11-3"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subclasse">Subclasse</label>
                <input
                  type="text"
                  id="subclasse"
                  name="subclasse"
                  value={formData.subclasse}
                  onChange={handleInputChange}
                  placeholder="Ex: 0111-3/01"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="dig">Dig (Dígitos)</label>
                <input
                  type="text"
                  id="dig"
                  name="dig"
                  value={formData.dig}
                  onChange={handleInputChange}
                  placeholder="Ex: 01"
                />
              </div>
              <div className="form-group">
                <label htmlFor="ref">Referência (Órgão)</label>
                <select
                  id="ref"
                  name="ref"
                  value={formData.ref}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione um órgão de referência</option>
                  {orgaosReferencia
                    .filter((o) => o.ativo)
                    .map((orgao) => (
                      <option key={orgao.id} value={orgao.id}>
                        {orgao.sigla
                          ? `${orgao.sigla} - ${orgao.nome_orgao_referencia}`
                          : orgao.nome_orgao_referencia}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="descricao">Descrição</label>
              <textarea
                id="descricao"
                name="descricao"
                value={formData.descricao}
                onChange={handleInputChange}
                placeholder="Descrição da atividade..."
                rows="4"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo-cnae"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData((prev) => ({ ...prev, ativo: e.target.checked }))}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar atividades CNAE..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando atividades CNAE...'
                  : `${filteredAtividades.length} registro(s) encontrado(s)`}
              </span>
            </div>
            <button
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Atividade
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>Seç</th>
                  <th style={{ width: '50px' }}>Div</th>
                  <th style={{ width: '60px' }}>Grupo</th>
                  <th style={{ width: '80px' }}>Classe</th>
                  <th style={{ width: '90px' }}>Subclasse</th>
                  <th style={{ width: '50px' }}>Dig</th>
                  <th style={{ width: '80px' }}>Ref</th>
                  <th>Descrição</th>
                  <th className="acoes-col" style={{ width: '80px' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredAtividades.map((atividade) => (
                  <tr key={atividade.id || atividade.referencia}>
                    <td style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                      {atividade.secao}
                    </td>
                    <td style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                      {atividade.divisao}
                    </td>
                    <td style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                      {atividade.grupo}
                    </td>
                    <td style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                      {atividade.classe}
                    </td>
                    <td style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                      {atividade.subclasse}
                    </td>
                    <td style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                      {atividade.dig || '-'}
                    </td>
                    <td style={{ fontSize: '0.85rem' }} title={atividade.referencia_nome || ''}>
                      {atividade.ref || '-'}
                    </td>
                    <td style={{ maxWidth: '500px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                      {atividade.descricao}
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(atividade)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(atividade.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AtividadesCNAE;
